import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CostCenterCodeMappingMaintenanceCont from "presentation/view/container/CostCenterCodeMapping/CostCenterCodeMappingContMain";

CommonEntrypoint(<CostCenterCodeMappingMaintenanceCont/>)